import { DialogRef, DIALOG_DATA } from '@angular/cdk/dialog';
import { Component, Inject } from '@angular/core';

// Dialogues
import { GenericConfirmDialogData } from '@core/models/depreciation.interface';



@Component({
  selector: 'rental-generic-confirm-dialog',
  templateUrl: './generic-confirm-dialog.component.html',
  styleUrls: ['./generic-confirm-dialog.component.scss']
})
export class GenericConfirmDialogComponent {

  public title!: string;
  public info!: string | undefined;
  public confirm!: string;
  public cancel!: string;


  constructor(
    public dialogRef: DialogRef<boolean>,
    @Inject(DIALOG_DATA) public readonly data: GenericConfirmDialogData
  ) {
    this.title = this.data?.title;
    this.info = this.data?.info;
    this.confirm = this.data?.confirm;
    this.cancel = this.data?.cancel;
  }


  public close(confirm: boolean): void {
    this.dialogRef.close(confirm);
  }
}



